/**
 * Nsection B16 Service
 * B.16.方法論原則 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b16';

export interface NsectionB16Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  encouraging_ambition: string | null;
  equitable_sharing: string | null;
  broad_participation: string | null;
  attributability: string | null;
  perverse_incentives: string | null;
  rebound_effects: string | null;
  nsection_b16_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB16Update {
  encouraging_ambition?: string;
  equitable_sharing?: string;
  broad_participation?: string;
  attributability?: string;
  perverse_incentives?: string;
  rebound_effects?: string;
}

const nsectionB16Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB16Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB16Update): Promise<NsectionB16Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB16Service;
